import apiUsers from '@/api/all-users'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getAllUsersStart: '[all users] Get all users start',
  getAllUsersSuccess: '[all users] Get all users success',
  getAllUsersFailure: '[all users] Get all users failure',

  getAllUsersByParamsStart: '[all users] Get all users by params start',
  getAllUsersByParamsSuccess: '[all users] Get all users by params success',
  getAllUsersByParamsFailure: '[all users] Get all users by params failure'
}

export const actionTypes = {
  getAllUsers: '[all users] Get all users',
  getAllUsersByParams: '[all users] Get all users by params'
}

const mutations = {
  [mutationTypes.getAllUsersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAllUsersSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getAllUsersFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getAllUsersByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getAllUsersByParamsSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getAllUsersByParamsFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getAllUsers](context) {
    context.commit(mutationTypes.getAllUsersStart)
    return new Promise(resolve => {
      apiUsers
        .getAllUsers()
        .then(response => {
          context.commit(mutationTypes.getAllUsersSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAllUsersFailure)
        })
    })
  },

  [actionTypes.getAllUsersByParams](context, {params}) {
    context.commit(mutationTypes.getAllUsersByParamsStart)
    return new Promise(resolve => {
      apiUsers
        .getAllUsersByParams(params)
        .then(response => {
          const allUsers = response.data ? response.data : response
          context.commit(mutationTypes.getAllUsersByParamsSuccess, response)
          resolve(allUsers)
        })
        .catch(() => {
          context.commit(mutationTypes.getAllUsersByParamsFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
